import { all } from "redux-saga/effects";
import getCRMLevelInfo from "./getCRMLevelInfo";

export const infoLoyaltyPageSaga = function* root() {
	yield all([getCRMLevelInfo()]);
};
